import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { ResponseService } from 'src/services/response.service';
import { ReplaySubject, combineLatest, debounceTime, fromEvent, throwError } from 'rxjs';
import { ResponseText } from 'src/models/app-enums.model';
import { ReplacePatientTermPipe } from "../filter-section.pipe";
import { SharedDataService } from 'src/services/shared-data.service';
import { QuestionnaireResponseAnswer, QuestionnaireResponseQuestion } from 'src/models/questionnaire-response.model';
import { ResponseAnswerUpdateRequest } from 'src/models/response.model';
import { DateUtil } from 'src/app/shared/utils/date.util';

@Component({
    selector: 'app-skip-logic-question',
    templateUrl: './skip-logic-question.component.html',
    styleUrls: ['./skip-logic-question.component.css'],
    standalone: true,
    imports: [MaterialModule, CommonModule, FormsModule, ReplacePatientTermPipe]
})
export class SkipLogicQuestionComponent implements OnInit {

  @Input() question!: QuestionnaireResponseQuestion;
  @Input() otherAnswerPlaceholder!: string;
  @ViewChild("myTextArea") textArea!: any

  patientTerm!: string;
  isPreview: boolean = false

  answersRadio!: QuestionnaireResponseAnswer[];
  answersCheckbox!: QuestionnaireResponseAnswer[];

  isCheckboxesDisabled: boolean = true
  isOtherTextBoxInCheckboxDisabled: boolean = false;
  isOtherTextboxInCheckboxValid: boolean = true;
  maxOtherAnswerCount = ResponseText.maxOtherAnswerCount;

  /**
   * 
   * @returns 
   */
  get isQuestionAnswered(): boolean {

    for(let ans of this.answersRadio) {
      if(ans.selected) {
        // No and prefer not to Answer
        if(ans.scaleValue !== '1') {
          return true
        }
      }
    }

    let isAnswered: boolean = false;
    // will reach here if scaleValue is 1 / YES
    for(let ans of this.answersCheckbox) {
      if(ans.selected) {
        // TODO - UNCOMMENT if textbox needs to be mandatory
        // if(ans.scaleValue === '996') {
        //   return this.question.responseText !== "" ? true : false
        // } else {
        //   isAnswered = true
        // }

        // TODO - REMOVE if textbox needs to be mandatory
        isAnswered = true
      }
    }

    return isAnswered
  }
       
  constructor(
    private _responseService: ResponseService, 
    private _sharedDataService: SharedDataService
  ) {}

  ngOnInit(): void {

    // pull patient term and preview mode
    combineLatest([this._sharedDataService.previewMode$, this._sharedDataService.patientTerm$])
      .subscribe(([isPreview, patientTerm]) => {
        this.isPreview = isPreview
        this.patientTerm = patientTerm
      }
    )

    this.answersRadio = this.question.answers.slice(0, 3);
    this.answersCheckbox = this.question.answers?.slice(3);

    this.isCheckboxesDisabled = this.answersRadio.find(ans => ans.scaleValue === '1' && ans.selected) ? false : true
    this.isOtherTextBoxInCheckboxDisabled = this.answersCheckbox.find(ans => ans.scaleValue === '996' && ans.selected) ? false : true
    // TODO - UNCOMMENT if textbox needs to be mandatory
    // this.isOtherTextboxInCheckboxValid = this.isOtherTextBoxInCheckboxDisabled ? true : this.question.responseText.trim() !== ""
  }

  /**
   * 
   * @param checkBoxAnswer 
   */
  onChangeCheckbox(checkBoxAnswer: QuestionnaireResponseAnswer, isSelected: boolean) {

    checkBoxAnswer.selected = isSelected

    if(isSelected) {
      // disable everything except for [Don't know] || [Prefer not to answer] option
      if(checkBoxAnswer.scaleValue === '999' || checkBoxAnswer.scaleValue === '997') {
        this.answersCheckbox.forEach(ans => {
          if(ans.answerId !== checkBoxAnswer.answerId) {
            ans.selected = false
          }
        })

        // diasable other text box
        this.question.responseText = ""
        this.isOtherTextBoxInCheckboxDisabled = true
        // TODO - UNCOMMENT if textbox needs to be mandatory
        // this.isOtherTextboxInCheckboxValid = this.isOtherTextBoxInCheckboxDisabled ? true : this.question.responseText.trim() !== ""
        
      } else {
        this.answersCheckbox.forEach(ans => {
          if(ans.scaleValue === '999' || ans.scaleValue === '997') {
            ans.selected = false
          }
        })
      }
    }
    if(checkBoxAnswer.scaleValue === '996') {
      this.question.responseText = "";
      this.isOtherTextBoxInCheckboxDisabled = !checkBoxAnswer.selected
      // TODO - UNCOMMENT if textbox needs to be mandatory
      // this.isOtherTextboxInCheckboxValid = this.isOtherTextBoxInCheckboxDisabled ? true : this.question.responseText.trim() !== ""
      // if(!isSelected) {
      //   this.saveSelectionCheckbox(checkBoxAnswer)
      // } else {
      //   this.question.isAnswered = false
      // }
      // // do not update answer unless text is entered
      // return 
    }

    this.saveSelectionCheckbox(checkBoxAnswer)
  }  

  /**
   * 
   * @param text 
   */
  updateOtherTextBoxValidity(text: string) {
    // TODO - UNCOMMENT if textbox needs to be mandatory
    // this.isOtherTextboxInCheckboxValid = text.trim() === "" ? false : true
    this.question.responseText = text
  }

  /**
   * 
   */
  saveOtherTextBoxAnswer(otherTextboxInCheckboxBoxAnswer: QuestionnaireResponseAnswer) {

    // update Text Box Validity
    this.updateOtherTextBoxValidity(this.question.responseText)

    if(!this.isOtherTextboxInCheckboxValid && otherTextboxInCheckboxBoxAnswer.selected) {
      this.question.isAnswered = this.isQuestionAnswered
      return
    }

    const otherTextBoxAnswer = this.answersCheckbox.find(ans => ans.scaleValue === '996')
    if(otherTextBoxAnswer === undefined) {
      throw throwError('Answer was not found')
    }

    const selectedAnswers: QuestionnaireResponseAnswer[] = this.answersRadio.concat(this.answersCheckbox).filter(ans => ans.selected)

    const responseAnswerUpdateRequest: ResponseAnswerUpdateRequest = {
      responseId: this._sharedDataService.questionnaireResponse!.responseId,
      question: {
        questionId: this.question.questionId,
        responseText: this.question.responseText,
        answers: selectedAnswers
      },
      isPreview: this.isPreview
    }

    this._responseService.updateSingleAnswerForResponse(responseAnswerUpdateRequest).subscribe(() => {
      this.question.isAnswered = this.isQuestionAnswered;
    })
  }

  /**
   * 
   * @param selectedAnswer 
   */
  saveSelectionCheckbox(selectedAnswer: QuestionnaireResponseAnswer) {
    // update checkbox answers
    this.answersCheckbox.map(ans => {
      if(ans.answerId === selectedAnswer.answerId) {
        ans.selected = selectedAnswer.selected
        ans.responseTimestamp = DateUtil.toISOString(new Date())
      }
      return ans
    })

    const selectedAnswers: QuestionnaireResponseAnswer[] = this.answersRadio.concat(this.answersCheckbox).filter(ans => ans.selected)

    this.question.isAnswered = false;
    const responseAnswerUpdateRequest : ResponseAnswerUpdateRequest = {
      responseId: this._sharedDataService.questionnaireResponse!.responseId,
      question: {
        questionId: this.question.questionId,
        responseText: this.question.responseText,
        answers: selectedAnswers
      },
      isPreview: this.isPreview
    }

    this._responseService.updateSingleAnswerForResponse(responseAnswerUpdateRequest).subscribe(() => {
      // update global questions
      this.question.answers = this.question.answers.map(ans => {
        const selectedAnswersIds: string[] = selectedAnswers.map(a => a.answerId)
        ans.selected = selectedAnswersIds.includes(ans.answerId)
        return ans
      })
      this.question.isAnswered = this.isQuestionAnswered;
    })
  }

  /**
   * Save radio selection
   * @param selectedAnswer 
   */
  saveSelectionRadio(selectedAnswer: QuestionnaireResponseAnswer) {

    // toggle checkboxes
    this.isCheckboxesDisabled = selectedAnswer.scaleValue !== '1'

    // update radio answers
    this.answersRadio.map(ans => {
      if(ans.answerId === selectedAnswer.answerId) {
        ans.selected = true
        ans.responseTimestamp = DateUtil.toISOString(new Date())
      } else {
        ans.selected = false
      }
      return ans
    })

    // reset checkbox answers
    this.answersCheckbox.map(ans => {
      ans.selected = false
      return ans
    })

    const selectedAnswers: QuestionnaireResponseAnswer[] = this.answersRadio.filter(ans => ans.selected)

    // reset response text
    this.question.responseText = ""

    const responseAnswerUpdateRequest : ResponseAnswerUpdateRequest = {
      responseId: this._sharedDataService.questionnaireResponse!.responseId,
      question: {
        questionId: this.question.questionId,
        responseText: this.question.responseText,
        answers: selectedAnswers
      },
      isPreview: this.isPreview
    }

    this._responseService.updateSingleAnswerForResponse(responseAnswerUpdateRequest).subscribe(() => {
      this.isOtherTextboxInCheckboxValid = this.isOtherTextBoxInCheckboxDisabled = true
      // update global questions
      this.question.answers = this.question.answers.map(ans => {
        const selectedAnswersIds: string[] = selectedAnswers.map(a => a.answerId)
        ans.selected = selectedAnswersIds.includes(ans.answerId)
        return ans
      })
      this.question.isAnswered = this.isQuestionAnswered
    })
  }


}
